<template>
  <div class="mod-demo-echarts">
    <mainOrgHome v-if="orgFlag && isAdmin == false" />
    <mainNaturalHome v-if="natFlag && isAdmin == false" />
    <mainSuperHome v-if="isAdmin == true" />
  </div>
</template>
<script>
  import {mapState} from "vuex";
  import store from '@/store'
  import mainOrgHome from '../modules/mainDealManagement/index';
  import mainNaturalHome from '../modules/naturalBasicInformation/index'
  import mainSuperHome from '../modules/mainBodyInformationList/index'
  export default {
    data(){
      return {
        loadingFlag:true,
        orgFlag:false,
        natFlag:false,
        isAdmin:false,
      }
    },
    created(){
      this.showBasicInfo();
      this.getSysIsAdmin();
    },
    computed:{
      ...mapState({
        id:(state) => state.user.orgId,//法人
        entId:(state) => state.user.userinfo.userId,//自然人
      })
    },
    components:{
      mainOrgHome,
      mainNaturalHome,
      mainSuperHome,
    },
    methods:{
      getSysIsAdmin(){
        this.$http.post('/sys/isAdmin').then(res=>{
          if(res.data && res.data.code ==1){
            this.isAdmin = res.data.data.isSupperAdmin;
            sessionStorage.setItem('fileUrl',res.data.data.fileUrl) // 本地存储当前环境的网址前缀
          }
        })
      },
      showBasicInfo(){ //如果法人ID存在 展示法人
        if(!!this.id && this.isAdmin == false){
          this.orgFlag = true;
        }else if(!!this.entId && this.isAdmin == false){//如果自然人ID存在 展示自然人
          this.natFlag = true;
        }else if(!!this.id && !!this.entId && this.isAdmin == false){ //如果都存在 展示法人
          this.orgFlag = true;
        }else if(this.isAdmin == true){

        }
      },
    }
  }
</script>

<style lang="scss">

</style>
